import React, { useEffect, useState } from 'react'
import { getTeacherSubjectSubscription } from '../../../services/teacher subcription/teacherSubcription';
import { useDispatch, useSelector } from 'react-redux';
import SubjectView from './SubjectView';
import { useNavigate } from 'react-router-dom';
import { setSubscriptions } from '../../../store/actions/subscriptionActions';
import Grid2 from '@mui/material/Unstable_Grid2';

function SubjectList() {
    
    const [loading, setLoading] = useState(false)
    const [subsCriptions, setSubsCriptions] = useState([])
    const user = useSelector(state => state.userReducer.user);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
      loadSubscriptionSubjects()
    }, [])
    

    const loadSubscriptionSubjects = async () => {
    try {
      const { myTeachers } = user
      if(myTeachers.length == 0){
        console.log('No teacher found')
        return;
      }
      const { id: userId = -1 } = myTeachers[0]

      const response = await getTeacherSubjectSubscription(userId)
      if (response.status === 200) {
        setSubsCriptions(response.data)
        dispatch(setSubscriptions(response.data))
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleSubjectTopicButtonClick = (subjectId) => {
    const syllabusId1 = 1;
    navigate('subject-topics', {
      state: {
        subjectId: subjectId,
        syllabusId: syllabusId1,
      },
    });
  };

   const handleQuestionsButtonClick = (subjectId ) => {
    const syllabusId1 = 1;

  //  console.log("subject id",subjectId)
    navigate(`questionsBank/${subjectId}`, {
      state: {
        syllabusId:syllabusId1,
        subjectId:subjectId
      },
    });
  };

  return (
    <Grid2 container spacing={2} sx={{ padding: 2 }}>
        {
            subsCriptions.map((sub, index) => (
              <Grid2 item xs={12} sm={6} md={4} lg={3} key={index}>
                <SubjectView key={index} subscription = {sub} onTopics = {handleSubjectTopicButtonClick}
                    onQuestions = {handleQuestionsButtonClick}
                />
              </Grid2>
            ))
        }
        </Grid2>
  )
}

export default SubjectList